import React, { useState } from 'react';
import appleStoreLogo from '../../assets/img/app_store.png'
// import googlePlayLogo from '../../assets/img/google_play.png'
import { Link } from "react-router-dom";
import ReactModal from 'react-modal';

ReactModal.setAppElement(document.getElementById('root'));

function ContactTrainer(props) {
  const [showModal, setShowModal] = useState(false);

  // const { onHide } = props;

  function openModal() {
    setShowModal(true);
  }

  function closeModal() {
    setShowModal(false);
  }

  return (
    <>
      <button
        onClick={openModal}
        className="primary-button w-full md:w-32 mr-0 md:mr-3">
        Contact Trainer
      </button>

      <ReactModal
        isOpen={showModal}
        onRequestClose={closeModal}>
        <button className='hover:bg-secondary text-blue-900 text-sm hover:text-blue-500 py-2 px-2 rounded absolute top-1 right-1 font-bold focus:outline-none'
          onClick={closeModal}>
          <svg className="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
          </svg>
        </button>

        <h2 className="text-xl text-center">Contact Trainer</h2>
        <hr className="h-px my-4 bg-gray-500 border-0 dark:bg-gray-700"></hr>
        <h4 className="m-4 mt-2 text-base">Download our free app to communicate with your trainer </h4>

        <div className="flex w-full justify-evenly">

          <Link to={{ pathname: 'https://apps.apple.com/us/app/trayvo/id1583924749' }}
            rel="noopener noreferrer"
            target="_blank">
            <img className="object-cover w-40"
              src={appleStoreLogo}
              alt='' />
          </Link>

          {/* <Link to={{ pathname: '#' }}
              rel="noopener noreferrer"
              target="_blank">
              <img className="object-cover w-40"
                src={googlePlayLogo}
                alt='' />
            </Link> */}

        </div>
      </ReactModal>
    </>
  );
}

export default ContactTrainer;
